import Immutable from 'seamless-immutable';
import { RETRIEVE_AVAILABLE_TOP_UPS, SUBMIT_TOP_UP_REQUEST } from './actions/customer.top.ups.actions';
export var INITIAL_STATE = Immutable({
  availableTopUps: null,
  isFetchingTopUps: false,
  isSubmittingTopUp: false,
  lastAttemptError: null
});
export default function topUpsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    _ref$payload = _ref.payload,
    payload = _ref$payload === void 0 ? {} : _ref$payload,
    type = _ref.type;
  switch (type) {
    case RETRIEVE_AVAILABLE_TOP_UPS.BEGIN:
      return state.set('isFetchingTopUps', true).set('availableTopUps', null).set('lastAttemptError', null);
    case RETRIEVE_AVAILABLE_TOP_UPS.SUCCESS:
      return state.set('isFetchingTopUps', false).set('availableTopUps', populateAvailableTopUpsMap(payload.AvailableTopUps));
    case RETRIEVE_AVAILABLE_TOP_UPS.FAILURE:
      return state.set('isFetchingTopUps', false).set('lastAttemptError', {
        code: payload.Code,
        message: payload.Message,
        severity: payload.Severity
      });
    case SUBMIT_TOP_UP_REQUEST.BEGIN:
      return state.set('isSubmittingTopUp', true).set('lastAttemptError', null);
    case SUBMIT_TOP_UP_REQUEST.SUCCESS:
      return state.set('isSubmittingTopUp', false);
    case SUBMIT_TOP_UP_REQUEST.FAILURE:
      return state.set('isSubmittingTopUp', false).set('lastAttemptError', {
        code: payload.Code,
        message: payload.translatedMessage,
        severity: payload.Severity
      });
    default:
      return state;
  }
}
function populateAvailableTopUpsMap(results) {
  var resultsMap = {};
  if (results) {
    results.forEach(function (service) {
      resultsMap[service.ServiceIdentifier] = service;
    });
  }
  return resultsMap;
}